import { render, staticRenderFns } from "./RSVP.vue?vue&type=template&id=2d0f8fea&"
import script from "./RSVP.vue?vue&type=script&lang=js&"
export * from "./RSVP.vue?vue&type=script&lang=js&"
import style0 from "./RSVP.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RSVP.vue"
export default component.exports